import i18n from '../i18n';

const DATABASE_ERROR_PATTERNS = [
  'error while accessing the database',
  'there was an error while accessing the database',
];

export const localizeApiError = (message: string): string => {
  const lang = (i18n.language || 'se').toLowerCase();
  const useSwedish = lang === 'se' || lang.startsWith('sv');
  if (!useSwedish || !message) {
    return message;
  }

  const lower = message.toLowerCase();
  if (DATABASE_ERROR_PATTERNS.some((pattern) => lower.includes(pattern))) {
    return (i18n.t as (key: string) => string)('ApiErrorDatabase');
  }

  return message;
};
